<template>
    <div>
        <div class="tit-wrap">
            <h3 class="tit top-line-tit">중앙아시아</h3>
        </div>

        <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer mobile-breakpoint="0" @page-count="pageCount = $event" class="v-data-table--default v-data-table--no-active"></v-data-table>

        <div class="v-pagination-wrap text-center">
            <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
        </div>
    </div>
</template>

<script>
import projectData from "@/assets/data/projects.json";

export default {
    components: {},
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                { text: "P/J 이름", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "고객", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "최종사용자", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "연도", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "서술", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            originalItems: projectData,
        };
    },
    computed: {
        items() {
            return this.originalItems.filter((item) => {
                const match = item.name.split(",").pop()?.trim();
                return match === "Iraq" || match === "Kuwait" || match === "Saudi" || match === "Saudi Arabia" || match === "Egypt" || match === "Oman" || match === "UAE" || match === "Algeria" || match === "Turkey";
            });
        },
    },
};
</script>

<style scoped></style>
